import React, {useEffect, useState} from 'react';
import {
  Button,
  RoundButton,
  Text,
  TextField,
  TooltipProvider,
  Icon,
} from '@cloudaper/react';

const Step3 = props => {
  const {
    validateToken,
    handleProcessCheck,
    handleGroupToggle,
    handleGroupInputChange,
    handleGroupInputAdd,
    handlePersonChange,
    handlePersonAdd,
    handlePersonRemove,
    handlePersonKeyDown,
    handleStrediskoAdd,
    handleStrediskoRename,
    handleStrediskoRemove,
    handleStartProcessSetup,
    handleSkipProcessSetup,
    startProcessSetup,
    postingResources,
    strediska,
    strediskaGroupInputs,
    optionalRoles,
    validateEmail,
    processWithErrors,
  } = props;

  useEffect(() => {
    document.title = 'Nastavení oběhu dokumentů - Začněte s Document Managerem';

    validateToken();
  }, [validateToken]);

  const [recepcniErrorDisplayed, setRecepcniErrorDisplayed] = useState(false);
  const [
    predschvalovatelErrorDisplayed,
    setPredschvalovatelErrorDisplayed,
  ] = useState(false);
  const [schvalovatelErrorDisplayed, setSchvalovatelErrorDisplayed] = useState(
    false,
  );
  const [ucetniErrorDisplayed, setUcetniErrorDisplayed] = useState(false);
  const [nahlizitelErrorDisplayed, setNahlizitelErrorDisplayed] = useState(
    false,
  );

  const tableClassName =
    strediska.length > 1
      ? `table tableSticky${
          optionalRoles.predschvalovatel && optionalRoles.nahlizitel
            ? ' tableWidest'
            : optionalRoles.predschvalovatel || optionalRoles.nahlizitel
            ? ' tableWider'
            : ''
        }`
      : `table${
          optionalRoles.predschvalovatel && optionalRoles.nahlizitel
            ? ' tableWider'
            : optionalRoles.predschvalovatel || optionalRoles.nahlizitel
            ? ' tableNarrower'
            : ' tableNarrowest'
        }`;

  const processStarted = strediska.some(
    stredisko =>
      strediska.length > 1 ||
      validateEmail(stredisko.recepcni.input) ||
      stredisko.recepcni.chips.length > 0 ||
      validateEmail(stredisko.predschvalovatel.input) ||
      stredisko.predschvalovatel.chips.length > 0 ||
      validateEmail(stredisko.schvalovatel.input) ||
      stredisko.schvalovatel.chips.length > 0 ||
      validateEmail(stredisko.ucetni.input) ||
      stredisko.ucetni.chips.length > 0 ||
      validateEmail(stredisko.nahlizitel.input) ||
      stredisko.nahlizitel.chips.length > 0,
  );

  const processWithoutStrediskoNames = strediska.some(
    stredisko => strediska.length > 1 && stredisko.stredisko.length === 0,
  );

  const processIncomplete = strediska.some(
    stredisko =>
      (!validateEmail(stredisko.recepcni.input) &&
        stredisko.recepcni.chips.length === 0) ||
      (!validateEmail(stredisko.schvalovatel.input) &&
        stredisko.schvalovatel.chips.length === 0) ||
      (!validateEmail(stredisko.ucetni.input) &&
        stredisko.ucetni.chips.length === 0),
  );

  const processCheckButtonText = processWithoutStrediskoNames
    ? 'Vyplňte názvy všech oddělení'
    : processStarted
    ? processWithErrors
      ? 'Odstraňte chyby výše'
      : processIncomplete
      ? 'Nechat nevyplněné role na mně a pokračovat ke kontrole'
      : 'Pokračovat ke kontrole'
    : 'Přeskočit';

  const recepcniError =
    strediskaGroupInputs.recepcni &&
    !validateEmail(strediskaGroupInputs.recepcni) &&
    recepcniErrorDisplayed;
  const predschvalovatelError =
    strediskaGroupInputs.predschvalovatel &&
    !validateEmail(strediskaGroupInputs.predschvalovatel) &&
    predschvalovatelErrorDisplayed;
  const schvalovatelError =
    strediskaGroupInputs.schvalovatel &&
    !validateEmail(strediskaGroupInputs.schvalovatel) &&
    schvalovatelErrorDisplayed;
  const ucetniError =
    strediskaGroupInputs.ucetni &&
    !validateEmail(strediskaGroupInputs.ucetni) &&
    ucetniErrorDisplayed;
  const nahlizitelError =
    strediskaGroupInputs.nahlizitel &&
    !validateEmail(strediskaGroupInputs.nahlizitel) &&
    nahlizitelErrorDisplayed;

  const recepcniAdd = () => {
    setRecepcniErrorDisplayed(true);
    handleGroupInputAdd('recepcni');
  };
  const predschvalovatelAdd = () => {
    setPredschvalovatelErrorDisplayed(true);
    handleGroupInputAdd('predschvalovatel');
  };
  const schvalovatelAdd = () => {
    setSchvalovatelErrorDisplayed(true);
    handleGroupInputAdd('schvalovatel');
  };
  const ucetniAdd = () => {
    setUcetniErrorDisplayed(true);
    handleGroupInputAdd('ucetni');
  };
  const nahlizitelAdd = () => {
    setNahlizitelErrorDisplayed(true);
    handleGroupInputAdd('nahlizitel');
  };

  return postingResources ? (
    <div className="appWrapper">
      <Text className="appConnectorCounter">
        <Icon className="postingResources" large name="gear-wheel" />
      </Text>

      <div className="appContent">
        <Text className="appHeading centeredText">
          Vaše skříň se právě sestavuje
        </Text>

        <br />
        <Text className="centeredText cardBodyText">
          Prosíme, nezavírejte tuto stránku.
        </Text>
      </div>
    </div>
  ) : (
    <div className="appWrapper">
      <div className="appConnectorString" />

      <Text className="appConnectorCounter">3</Text>

      <div className="appContent appContentMedium">
        <Text className="appHeading centeredText">
          Nastavte oběh dokumentů,
          <br />
          pozvěte své spolupracovníky
          <br />
          a&nbsp;přidělte jim role.
        </Text>
        <br />
        <Text className="centeredText cardBodyText">
          Zadejte jejich pracovní e-maily do všech rolí, které jim náleží.
          <br />
          Ten svůj přidávat nemusíte, protože jako zakládající správce máte
          přístup všude.
          <br />
          Případně můžete nastavování přeskočit a rovnou začít.
        </Text>
      </div>

      {!startProcessSetup && (
        <>
          <div className="appConnectorButtonWrapper">
            <Button
              className="appConnectorButton"
              kind="primary"
              onClick={handleStartProcessSetup}
              raised
            >
              Nastavit oběh
            </Button>
          </div>

          <div className="appConnectorButtonWrapper">
            <Button
              className="appConnectorButton"
              onClick={handleSkipProcessSetup}
              raised
            >
              Přeskočit a začít s DM
            </Button>
          </div>
        </>
      )}

      {startProcessSetup && (
        <>
          <div className="appContent appContentFullWidth">
            <div className={tableClassName}>
              <>
                {strediska.length > 1 && (
                  <div className="tableCell tableCellSticky tableCellFirst">
                    <div className="tableColorBlock tableColorBlockStrediska">
                      <Text className="tableColorHeading">Oddělení</Text>
                      <Text className="tableColorText cardBodyText">
                        Umožní rozdělit procesy podle oddělení, středisek nebo
                        třeba poboček. Kolegům můžete přidělit oddělení
                        jednotlivě nebo všechna zároveň.
                      </Text>
                    </div>
                    <div className="input"></div>
                  </div>
                )}

                <div className="tableCell tableCellBlock tableCellBlockFirst">
                  <div className="tableColorBlock tableColorBlockRecepcni">
                    <Text className="tableColorHeading">Recepční</Text>
                    <Text className="tableColorText cardBodyText">
                      Přidává, třídí a posouvá dokumenty ke schválení.
                    </Text>
                  </div>
                  {strediska.length > 1 && (
                    <div
                      className={`input${
                        recepcniError ? ' inputWithError' : ''
                      }`}
                    >
                      <TextField
                        iconAfter="arrow-down"
                        placeholder="Přidá e-mail všude"
                        value={strediskaGroupInputs.recepcni}
                        type="email"
                        id="dm-onboarding-step3-groupinput-recepcni"
                        error={recepcniError}
                        onFocus={() => setRecepcniErrorDisplayed(false)}
                        onBlur={() => setRecepcniErrorDisplayed(true)}
                        onChange={e => {
                          setRecepcniErrorDisplayed(false);
                          handleGroupInputChange('recepcni', e.target.value);
                        }}
                        handleEnter={recepcniAdd}
                        onIconAfterClick={recepcniAdd}
                      />
                    </div>
                  )}

                  {!optionalRoles.predschvalovatel && (
                    <>
                      <div className="tableCellAddRole">
                        <TooltipProvider tooltip="Předschvalovatel dokumenty kontroluje a posílá je dál.">
                          <Button
                            dense
                            raised
                            kind="primary"
                            onClick={() =>
                              handleGroupToggle('predschvalovatel')
                            }
                          >
                            Přidat 2. úroveň schvalování
                          </Button>
                        </TooltipProvider>
                      </div>
                      <div className="tableCellArrow" />
                    </>
                  )}
                </div>

                {optionalRoles.predschvalovatel && (
                  <div className="tableCell tableCellBlock">
                    <div className="tableColorBlock tableColorBlockPredschvalovatel">
                      <Text className="tableColorHeading">
                        Předschvalovatel
                      </Text>
                      <Text className="tableColorText cardBodyText">
                        Kontroluje dokumenty a posílá je ke schválení
                        nadřízeným.
                      </Text>
                    </div>
                    {strediska.length > 1 && (
                      <div
                        className={`input${
                          predschvalovatelError ? ' inputWithError' : ''
                        }`}
                      >
                        <TextField
                          iconAfter="arrow-down"
                          placeholder="Přidá e-mail všude"
                          value={strediskaGroupInputs.predschvalovatel}
                          type="email"
                          id="dm-onboarding-step3-groupinput-predschvalovatel"
                          error={predschvalovatelError}
                          onFocus={() =>
                            setPredschvalovatelErrorDisplayed(false)
                          }
                          onBlur={() => setPredschvalovatelErrorDisplayed(true)}
                          onChange={e => {
                            setPredschvalovatelErrorDisplayed(false);
                            handleGroupInputChange(
                              'predschvalovatel',
                              e.target.value,
                            );
                          }}
                          handleEnter={predschvalovatelAdd}
                          onIconAfterClick={predschvalovatelAdd}
                        />
                      </div>
                    )}

                    <div className="tableCellBlockHide">
                      <RoundButton
                        onClick={() => handleGroupToggle('predschvalovatel')}
                        iconName="cross"
                      />
                    </div>
                  </div>
                )}

                <div className="tableCell tableCellBlock">
                  <div className="tableColorBlock tableColorBlockSchvalovatel">
                    <Text className="tableColorHeading">Schvalovatel</Text>
                    <Text className="tableColorText cardBodyText">
                      Schvaluje dokumenty a předává je účetním.
                    </Text>
                  </div>
                  {strediska.length > 1 && (
                    <div
                      className={`input${
                        schvalovatelError ? ' inputWithError' : ''
                      }`}
                    >
                      <TextField
                        iconAfter="arrow-down"
                        placeholder="Přidá e-mail všude"
                        value={strediskaGroupInputs.schvalovatel}
                        type="email"
                        id="dm-onboarding-step3-groupinput-schvalovatel"
                        error={schvalovatelError}
                        onFocus={() => setSchvalovatelErrorDisplayed(false)}
                        onBlur={() => setSchvalovatelErrorDisplayed(true)}
                        onChange={e => {
                          setSchvalovatelErrorDisplayed(false);
                          handleGroupInputChange(
                            'schvalovatel',
                            e.target.value,
                          );
                        }}
                        handleEnter={schvalovatelAdd}
                        onIconAfterClick={schvalovatelAdd}
                      />
                    </div>
                  )}
                </div>

                <div
                  className={`tableCell tableCellBlock${
                    optionalRoles.nahlizitel ? '' : ' tableCellBlockLast'
                  } tableCellBlockUcetni`}
                >
                  <div className="tableColorBlock tableColorBlockUcetni">
                    <Text className="tableColorHeading">Účetní</Text>
                    <Text className="tableColorText cardBodyText">
                      Zaúčtovává nebo platí schválené dokumenty a archivuje je.
                    </Text>
                  </div>
                  {strediska.length > 1 && (
                    <div
                      className={`input${ucetniError ? ' inputWithError' : ''}`}
                    >
                      <TextField
                        iconAfter="arrow-down"
                        placeholder="Přidá e-mail všude"
                        value={strediskaGroupInputs.ucetni}
                        type="email"
                        id="dm-onboarding-step3-groupinput-ucetni"
                        error={ucetniError}
                        onFocus={() => setUcetniErrorDisplayed(false)}
                        onBlur={() => setUcetniErrorDisplayed(true)}
                        onChange={e => {
                          setUcetniErrorDisplayed(false);
                          handleGroupInputChange('ucetni', e.target.value);
                        }}
                        handleEnter={ucetniAdd}
                        onIconAfterClick={ucetniAdd}
                      />
                    </div>
                  )}

                  {!optionalRoles.nahlizitel && (
                    <>
                      <div className="tableCellAddRole">
                        <TooltipProvider tooltip="Nahližitel může pouze nahlížet.">
                          <Button
                            dense
                            raised
                            kind="primary"
                            onClick={() => handleGroupToggle('nahlizitel')}
                          >
                            Přidat přístup pro nahlížení
                          </Button>
                        </TooltipProvider>
                      </div>
                      <div className="tableCellArrow" />
                    </>
                  )}
                </div>

                {optionalRoles.nahlizitel && (
                  <div className="tableCell tableCellBlock tableCellBlockLast">
                    <div className="tableColorBlock tableColorBlockNahlizitel">
                      <Text className="tableColorHeading">Nahližitel</Text>
                      <Text className="tableColorText cardBodyText">
                        Může do dokumentů v průběhu procesu pouze nahlížet.
                      </Text>
                    </div>
                    {strediska.length > 1 && (
                      <div
                        className={`input${
                          nahlizitelError ? ' inputWithError' : ''
                        }`}
                      >
                        <TextField
                          iconAfter="arrow-down"
                          placeholder="Přidá e-mail všude"
                          value={strediskaGroupInputs.nahlizitel}
                          type="email"
                          id="dm-onboarding-step3-groupinput-nahlizitel"
                          error={nahlizitelError}
                          onFocus={() => setNahlizitelErrorDisplayed(false)}
                          onBlur={() => setNahlizitelErrorDisplayed(true)}
                          onChange={e => {
                            setNahlizitelErrorDisplayed(false);
                            handleGroupInputChange(
                              'nahlizitel',
                              e.target.value,
                            );
                          }}
                          handleEnter={nahlizitelAdd}
                          onIconAfterClick={nahlizitelAdd}
                        />
                      </div>
                    )}

                    <div className="tableCellBlockHide">
                      <RoundButton
                        onClick={() => handleGroupToggle('nahlizitel')}
                        iconName="cross"
                      />
                    </div>
                  </div>
                )}
              </>

              {strediska.map((stredisko, idx) => (
                <React.Fragment key={`${stredisko}_${idx}`}>
                  {strediska.length > 1 && (
                    <div className="tableCell tableCellSticky">
                      <TextField
                        error={
                          processWithErrors &&
                          (stredisko.stredisko.length === 0
                            ? 'Oddělení musí mít název'
                            : strediska.some((item, index) => {
                                if (index === idx) {
                                  return false;
                                }
                                return item.stredisko === stredisko.stredisko;
                              })
                            ? 'Střediska se nesmí jmenovat stejně'
                            : stredisko.stredisko.length > 24
                            ? 'Název je příliš dlouhý'
                            : false)
                        }
                        iconAfter="cross"
                        onIconAfterClick={() => handleStrediskoRemove(idx)}
                        onChange={e =>
                          handleStrediskoRename(idx, e.target.value)
                        }
                        onBlur={handleProcessCheck}
                        placeholder={['Praha', 'Brno', 'Ostrava'][idx % 3]}
                        helper="Název oddělení"
                        value={stredisko.stredisko}
                        id={`dm-onboarding-step3-${idx}-stredisko`}
                      />
                    </div>
                  )}

                  <div className="tableCell recepcni">
                    <TextField
                      error={
                        processWithErrors &&
                        stredisko.recepcni.input.length > 0 &&
                        !validateEmail(stredisko.recepcni.input) &&
                        'E-mail není ve správném formátu'
                      }
                      chipped
                      chips={stredisko.recepcni.chips}
                      onKeyDown={e =>
                        handlePersonKeyDown(
                          e,
                          idx,
                          'recepcni',
                          stredisko.recepcni.input,
                        )
                      }
                      onChange={e =>
                        handlePersonChange(idx, 'recepcni', e.target.value)
                      }
                      onBlur={() => {
                        handleProcessCheck();
                        handlePersonAdd(
                          idx,
                          'recepcni',
                          stredisko.recepcni.input,
                        );
                      }}
                      handleEnter={chip =>
                        handlePersonAdd(idx, 'recepcni', chip)
                      }
                      handleChipRemove={chipIdx =>
                        handlePersonRemove(idx, 'recepcni', chipIdx)
                      }
                      placeholder="E-mailová adresa"
                      helper="E-mailové adresy všech recepčních"
                      value={stredisko.recepcni.input}
                      id={`dm-onboarding-step3-${idx}-recepcni`}
                    />
                  </div>

                  {optionalRoles.predschvalovatel && (
                    <div className="tableCell predschvalovatel">
                      <TextField
                        error={
                          processWithErrors &&
                          stredisko.predschvalovatel.input.length > 0 &&
                          !validateEmail(stredisko.predschvalovatel.input) &&
                          'E-mail není ve správném formátu'
                        }
                        chipped
                        chips={stredisko.predschvalovatel.chips}
                        onKeyDown={e =>
                          handlePersonKeyDown(
                            e,
                            idx,
                            'predschvalovatel',
                            stredisko.predschvalovatel.inputs,
                          )
                        }
                        onChange={e =>
                          handlePersonChange(
                            idx,
                            'predschvalovatel',
                            e.target.value,
                          )
                        }
                        onBlur={() => {
                          handleProcessCheck();
                          handlePersonAdd(
                            idx,
                            'predschvalovatel',
                            stredisko.predschvalovatel.input,
                          );
                        }}
                        handleEnter={chip =>
                          handlePersonAdd(idx, 'predschvalovatel', chip)
                        }
                        handleChipRemove={chipIdx =>
                          handlePersonRemove(idx, 'predschvalovatel', chipIdx)
                        }
                        placeholder="E-mailová adresa"
                        helper="E-mailové adresy všech předschvalovatelů"
                        value={stredisko.predschvalovatel.input}
                        id={`dm-onboarding-step3-${idx}-predschvalovatel`}
                      />
                    </div>
                  )}

                  <div className="tableCell schvalovatel">
                    <TextField
                      error={
                        processWithErrors &&
                        stredisko.schvalovatel.input.length > 0 &&
                        !validateEmail(stredisko.schvalovatel.input) &&
                        'E-mail není ve správném formátu'
                      }
                      chipped
                      chips={stredisko.schvalovatel.chips}
                      onKeyDown={e =>
                        handlePersonKeyDown(
                          e,
                          idx,
                          'schvalovatel',
                          stredisko.schvalovatel.input,
                        )
                      }
                      onChange={e =>
                        handlePersonChange(idx, 'schvalovatel', e.target.value)
                      }
                      onBlur={() => {
                        handleProcessCheck();
                        handlePersonAdd(
                          idx,
                          'schvalovatel',
                          stredisko.schvalovatel.input,
                        );
                      }}
                      handleEnter={chip =>
                        handlePersonAdd(idx, 'schvalovatel', chip)
                      }
                      handleChipRemove={chipIdx =>
                        handlePersonRemove(idx, 'schvalovatel', chipIdx)
                      }
                      placeholder="E-mailová adresa"
                      helper="E-mailové adresy všech schvalovatelů"
                      value={stredisko.schvalovatel.input}
                      id={`dm-onboarding-step3-${idx}-schvalovatel`}
                    />
                  </div>

                  <div className="tableCell ucetni">
                    <TextField
                      error={
                        processWithErrors &&
                        stredisko.ucetni.input.length > 0 &&
                        !validateEmail(stredisko.ucetni.input) &&
                        'E-mail není ve správném formátu'
                      }
                      chipped
                      chips={stredisko.ucetni.chips}
                      onKeyDown={e =>
                        handlePersonKeyDown(
                          e,
                          idx,
                          'ucetni',
                          stredisko.ucetni.input,
                        )
                      }
                      onChange={e =>
                        handlePersonChange(idx, 'ucetni', e.target.value)
                      }
                      onBlur={() => {
                        handleProcessCheck();
                        handlePersonAdd(idx, 'ucetni', stredisko.ucetni.input);
                      }}
                      handleEnter={chip => handlePersonAdd(idx, 'ucetni', chip)}
                      handleChipRemove={chipIdx =>
                        handlePersonRemove(idx, 'ucetni', chipIdx)
                      }
                      placeholder="E-mailová adresa"
                      helper="E-mailové adresy všech účetních"
                      value={stredisko.ucetni.input}
                      id={`dm-onboarding-step3-${idx}-ucetni`}
                    />
                  </div>

                  {optionalRoles.nahlizitel && (
                    <div className="tableCell nahlizitel">
                      <TextField
                        error={
                          processWithErrors &&
                          stredisko.nahlizitel.input.length > 0 &&
                          !validateEmail(stredisko.nahlizitel.input) &&
                          'E-mail není ve správném formátu'
                        }
                        chipped
                        chips={stredisko.nahlizitel.chips}
                        onKeyDown={e =>
                          handlePersonKeyDown(
                            e,
                            idx,
                            'nahlizitel',
                            stredisko.nahlizitel.input,
                          )
                        }
                        onChange={e =>
                          handlePersonChange(idx, 'nahlizitel', e.target.value)
                        }
                        onBlur={() => {
                          handleProcessCheck();
                          handlePersonAdd(
                            idx,
                            'nahlizitel',
                            stredisko.nahlizitel.input,
                          );
                        }}
                        handleEnter={chip =>
                          handlePersonAdd(idx, 'nahlizitel', chip)
                        }
                        handleChipRemove={chipIdx =>
                          handlePersonRemove(idx, 'nahlizitel', chipIdx)
                        }
                        placeholder="E-mailová adresa"
                        helper="E-mailové adresy všech nahližitelů"
                        value={stredisko.nahlizitel.input}
                        id={`dm-onboarding-step3-${idx}-nahlizitel`}
                      />
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>

            <div className="tableButton">
              {strediska.length > 1 && (
                <Button
                  raised
                  iconName="plus"
                  onClick={() => handleStrediskoAdd(1)}
                >
                  Přidat další oddělení
                </Button>
              )}

              {strediska.length === 1 && (
                <>
                  <Button
                    raised
                    iconName="plus"
                    onClick={() => handleStrediskoAdd(2)}
                  >
                    Rozdělit procesy podle oddělení
                  </Button>

                  <div className="tableButtonHelper">
                    <Text className="centeredText cardBodyText">
                      Nyní máte pouze jeden proces na celou firmu. Proces si
                      můžete představit jako cestu, kterou musí dokument projít,
                      aby se s ním firma správně vypořádala. Pokud máte více
                      nezávislých oddělení nebo například poboček, doporučujeme
                      jejich procesy rozdělit, aby byl v dokumentech pořádek.
                    </Text>
                  </div>
                </>
              )}
            </div>
          </div>

          <div className="appConnectorButtonWrapper">
            <Button
              className="appConnectorButton"
              disabled={
                processWithoutStrediskoNames ||
                ((!processStarted || processIncomplete) && processWithErrors) ||
                processWithErrors
              }
              kind="primary"
              onClick={() => handleProcessCheck(processStarted, true)}
              raised
            >
              {processCheckButtonText}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default Step3;
